var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-container",
    { staticClass: "p-0" },
    [
      _c(
        "v-row",
        { attrs: { "no-gutters": "" } },
        [
          _c(
            "v-col",
            [
              _c(_vm.currentComponent, {
                tag: "component",
                attrs: {
                  teamRequest: _vm.mutableTeamRequest,
                  onOpenModal: _vm.openModal,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(_vm.currentModalComponent, {
        tag: "component",
        attrs: {
          isOpen: _vm.isModalOpen,
          onClose: _vm.closeModal,
          teamRequest: _vm.mutableTeamRequest,
          teamRequestId: _vm.mutableTeamRequest.id,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }